import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = () => {
    return customAxios.get(CONFIG.apiURL + '/Departments').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Departments/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Departments/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/Departments/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};